module.exports = __webpack_public_path__ + "static/media/white-chevron-down-new.e908b404.svg";